import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEyeconxStore } from '../../../../../store/eyeconxStore';

function OverviewCards({ data, onFailedClick }) {
    const navigate = useNavigate();
    const smsInbox = useEyeconxStore((state) => state.smsInbox);

    const cards = [
        {
            title: 'Total Messages',
            icon: 'bi-envelope-paper',
            value: data.totalMessages || 0,
            gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            breakdown: [
                { label: 'Sent', value: data.messagesSent || 0 },
                { label: 'Received', value: data.messagesReceived || 0 },
            ],
        },
        {
            title: 'Delivered',
            icon: 'bi-send-check',
            value: data.messagesDelivered || 0,
            metric: `${data.sentSuccessRate || '0%'} success`,
            gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        },
        {
            title: 'Inbox',
            icon: 'bi-inbox-fill',
            value: data.messagesReceived || 0,
            metric: `${data.messagesUnread || 0} unread`,
            gradient: 'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
            hasBadge: true,
            onClick: () => navigate('/sms-messages', { state: { initialSort: 'unread_first' } }),
        },
        {
            title: 'Patients',
            icon: 'bi-people-fill',
            value: data.uniquePatientsContacted || 0,
            metric: `${data.readRate || '0%'} read rate`,
            gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
        },
        {
            title: 'Failed',
            icon: 'bi-x-circle-fill',
            value: data.messagesFailed || 0,
            metric: `${data.sentFailureRate || '0%'} failure rate`,
            gradient: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
            onClick: onFailedClick,
        },
        {
            title: 'In Process',
            icon: 'bi-hourglass-split',
            value: data.messagesInProcess || 0,
            metric: 'Processing',
            gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
        },
        {
            title: 'Confirmations',
            icon: 'bi-calendar-check',
            value: data.confirmationRequiredMessages || 0,
            metric: 'Appt confirmations',
            gradient: 'linear-gradient(135deg, #5c6bc0 0%, #3949ab 100%)',
        },
    ];

    return (
        <div className="row g-3">
            {cards.map((card, index) => (
                <div key={index} className="col-sm-6 col-md-4 col-xl">
                    <div
                        className={`card border-0 shadow h-100 overflow-hidden position-relative ${
                            card.onClick ? 'sms-dashboard-card--clickable' : ''
                        }`}
                        style={{ background: card.gradient }}
                        onClick={card.onClick}
                        onKeyDown={
                            card.onClick
                                ? (e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                          e.preventDefault();
                                          card.onClick();
                                      }
                                  }
                                : undefined
                        }
                        role={card.onClick ? 'button' : undefined}
                        tabIndex={card.onClick ? 0 : undefined}
                    >
                        <div className="card-body p-3 text-white position-relative" style={{ zIndex: 2 }}>
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-25"
                                    style={{ width: '48px', height: '48px' }}
                                >
                                    <i className={`bi ${card.icon} fs-3 text-white`}></i>
                                </div>
                                {card.hasBadge && smsInbox > 0 && (
                                    <span className="badge bg-danger text-white fw-normal px-2">{smsInbox}</span>
                                )}
                            </div>

                            <div>
                                <h6
                                    className="text-white fw-light mb-2 text-uppercase"
                                    style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}
                                >
                                    {card.title}
                                </h6>
                                <h1 className="fw-normal mb-0 text-white" style={{ fontSize: '2rem' }}>
                                    {card.value}
                                </h1>

                                {card.metric && (
                                    <p className="mb-0 mt-2 text-white" style={{ fontSize: '0.78rem', opacity: 0.9 }}>
                                        <i className="bi bi-graph-up-arrow me-1"></i>
                                        {card.metric}
                                    </p>
                                )}

                                {card.breakdown && (
                                    <div className="mt-3 pt-2 border-top border-white" style={{ borderOpacity: 0.3 }}>
                                        {card.breakdown.map((item, i) => (
                                            <div key={i} className="d-flex justify-content-between align-items-center mb-1">
                                                <span className="text-white" style={{ fontSize: '0.8rem', opacity: 0.85 }}>
                                                    {item.label}
                                                </span>
                                                <span className="text-white fw-normal" style={{ fontSize: '0.78rem' }}>
                                                    {item.value}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                        <i
                            className={`bi ${card.icon} position-absolute text-white`}
                            style={{
                                fontSize: '5rem',
                                right: '-15px',
                                bottom: '-15px',
                                opacity: 0.15,
                                zIndex: 1,
                            }}
                        ></i>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default OverviewCards;
